import { CollectionEntity } from "@busy-human/gearbox";
//crew members should not be able to log in but still be part of a unit.
export var CrewMember;
(function (CrewMember) {
    function Defaults() {
        return {
            companyId: "",
            name: null,
            type: null,
            phoneNumber: "",
            email: "",
            timestampCreated: new Date().toISOString(),
            timestampLastLogin: new Date().toISOString(),
            location: null,
        };
    }
    class CollectionClass extends CollectionEntity {
        relationships;
        defaults() {
            return Defaults();
        }
    }
    CrewMember.CollectionClass = CollectionClass;
})(CrewMember || (CrewMember = {}));
//# sourceMappingURL=index.js.map